import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { RetailerVietnamPage } from "./legal.retailer-vietnam";

export const Route = createFileRoute("/vi/legal/retailer-vietnam")({
  head: () => ({
    meta: [{ title: "Hợp đồng Đại lý (Việt Nam) — Banana Cards" }],
    links: alternateLinkList("/legal/retailer-vietnam", "vi"),
  }),
  component: RetailerVietnamPage,
});